import React from 'react';
import SignInForm from './SignInForm';

const SignInPage = () => {
  return <SignInForm />;
};

export default SignInPage;
